<template>
    <avue-draggable
        :index="data.index"
        :active="data.active"
        :width="data.width"
        :height="data.height"
        :left="data.left"
        :top="data.top"
        id="draggable"
        ref="draggable"
        @focus="handleFocus"
        @blur="handleBlur"
        @change="change"
    >
        <div
            ref="rect"
            style="position: relative; color: black"
            :style="{ background: colors[data.type] }"
        >
            <!-- <div
                style="
                    display: flex;
                    width: 100%;
                    height: 100%;
                    background-color: aqua;
                "
            ></div> -->
            <div
                style="
                    position: absolute;
                    left: 50%;
                    bottom: 0px;
                    transform: translateX(-50%);
                    font-size: 12px;
                    z-index: 99999;
                    text-shadow: 1px 1px 1px white;
                "
            >
                {{ data.width * lengthRate }}mm
            </div>
            <div
                style="
                    position: absolute;
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);
                    font-size: 12px;
                    z-index: 99999;
                    text-shadow: 1px 1px 1px white;
                "
            >
                {{ data.height * lengthRate }}mm
            </div>
        </div>
    </avue-draggable>
</template>
<script>
import { colors, dic_types } from "../api/options";
export default {
    components: {},
    name: "simple-rect",
    props: {
        data: Object,
        lengthRate: Number,
        index: Number,
    },
    data: () => {
        return {
            active: false,
            colors: colors,
        };
    },
    mounted() {
        this.updateLocation();
    },
    computed: {},
    watch: {
        "data.top": function () {
            this.updateLocation();
        },
    },
    methods: {
        updateLocation() {
            if (this.boundary) {
                let x = (this.data.left - this.boundary.left) * this.lengthRate;
                let y =
                    (this.boundary.top +
                        this.boundary.height -
                        (this.data.top + this.data.height)) *
                    this.lengthRate;
                this.location = `${x},${y}`;
            }
        },
        handleFocus() {
            this.active = true;
        },
        handleBlur({ width, height, top, left, index }) {
            left = left < 0 ? 0 : left;
            height = height < 0 ? 0 : height;
            top = top < 0 ? 0 : top;
            width = width < 0 ? 0 : width;
            left = this.round(left);
            height = this.round(height);
            top = this.round(top);
            width = this.round(width);
            this.$emit("rectChange", this.index, left, top, width, height);
        },
        round(num, ratio = 10) {
            return Math.round(num / ratio) * ratio;
        },
        setActive(act = false) {
            this.$refs.draggable.setActive(act);
            this.active = false;
        },
        change(...p) {
            console.log(p);
        },
    },
};
</script>
